import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const CheckmarkComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__checkmark"
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path d="M15 4.5L6.75 12.75L3 9" stroke={colorVar} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const Checkmark = withIcon(CheckmarkComponent);
